export default __webpack_public_path__ + "static/media/logo-home.478639f0.png";